/* Логика фильтрации товаров — вынесена из ProductGrid,
 * чтобы использовать её в App.js и CatalogPage.
 */

const norm = (s) => (s || '').toLowerCase();

const productText = (p) =>
    `${norm(p.category)} ${norm(p.name)} ${norm(p.keywords)}`;

export function detectBrand(p) {
    if (p.brand) return p.brand;
    const text = `${p.name || ''} ${p.description || ''}`.toLowerCase();
    if (text.includes('skin synergy')) return 'Skin Synergy';
    if (text.includes('soskin')) return 'SoSkin';
    if (text.includes('lendan')) return 'Lendan';
    if (text.includes('skinclinic')) return 'SkinClinic';
    return 'Другой';
}

export function matchesBrand(p, brandLabel) {
    if (!brandLabel) return true;
    return detectBrand(p) === brandLabel;
}

export function matchesCategory(p, categoryLabel) {
    if (!categoryLabel || categoryLabel === 'Все') return true;
    const text = productText(p);
    const desc = norm(p.description);
    if (text.includes(norm(categoryLabel))) return true;

    switch (categoryLabel) {
        case 'Сыворотки':
            return /сыворот|serum/.test(text);

        case 'Увлажняющие средства': {
            const isCleansing = /очищ|умыван|скраб|пилинг|пенк|cleans/.test(text);
            const isSpf = /spf|спф|солнц|фотозащит/.test(text);
            const isCare = /увлажн|питательн|восстанав|барьер|крем|гель|флюид|эмульс|маск|тонер|тоник|мист|молочко|hydrat|moistur/.test(text);
            return isCare && !isCleansing && !isSpf;
        }

        case 'Очищающие средства':
            return /очищ|умыван|скраб|пилинг|пенк|cleans|exfoliat/.test(text);

        case 'SPF':
            return /spf|спф|солнц|фотозащит|ультрафиолет/.test(text + ' ' + desc);

        case 'Наборы':
            return /набор|комплект|set/.test(text);

        default:
            return true;
    }
}

export function filterProducts(products, { brandLabel = '', categoryLabel = '' } = {}) {
    let list = products || [];
    if (brandLabel) list = list.filter((p) => matchesBrand(p, brandLabel));
    if (categoryLabel) list = list.filter((p) => matchesCategory(p, categoryLabel));
    return list;
}